// extracted by mini-css-extract-plugin
export default {"sliderContainer":"BannerSlider_sliderContainer__49gVH","slideImage":"BannerSlider_slideImage__WiLk0","textOverlay":"BannerSlider_textOverlay__BeWOY"};